/* eslint-disable no-underscore-dangle */

const _ = require('lodash');
const AttributeEvaluationResponse = require('./../../../AttributeEvaluationResponse/index');
const AttributeConstraintsFormula = require('./../index');
const Range = require('./../../../../NumericValues/Range');

module.exports = class RuleFormula extends AttributeConstraintsFormula {
  /**
   * See parent for details.
   * @param  {Object} config The configuration to build with.
   */
  constructor(config) {
    super(config);

    // false values will be evaluated again, once it evaluates to true it stops being checked
    this._evaluateState = false;
    // forcing this to true because we're currently only treating formulas as constraints
    this._isValid = true;
  }

  /**
   * Check if this Formula's validValue is contained by the given value
   * @param {string | Range}
   */
  isContainedBy(value) {
    const formulaValue = this._validValue.toString();

    if (value instanceof Range) {
      return value.contains(formulaValue);
    }

    return _.isEqual(formulaValue, value);
  }

  /**
   * Evaluates the current rule based on the provided attributeDomain.
   * NOTE: Currently we are only utilizing formulas as "intersection" constraints rather
   * than actual values.
   *
   * @param  {Object} attributeDomain The attribute domain to evaluate.
   */
  evaluate(attributeDomain) {
    const result = super.evaluate(attributeDomain);

    if (result.result) {
      if (_.has(attributeDomain, this._key.toLowerCase())) {
        const relevantSelections = attributeDomain[this._key.toLowerCase()];

        let comparisonResult = false;
        if (this.isValid) {
          comparisonResult = _.every(relevantSelections, relevantSelection => !this.isContainedBy(relevantSelection));
        } else {
          comparisonResult = _.every(relevantSelections, relevantSelection => this.isContainedBy(relevantSelection));
        }

        this._evaluateState = comparisonResult;
        return new AttributeEvaluationResponse(this._key, comparisonResult, this._evaluateState, {
          expression: this._formula,
          value: this._validValue.toString(),
        });
      }
    }

    return result;
  }
};
